var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('stripe-element-card',{ref:"elementRef",attrs:{"pk":_vm.pulishableKey,"hidePostalCode":""},on:{"token":_vm.tokenCreated}}),_c('v-btn',{on:{"click":_vm.submit}},[_vm._v("Generate token")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }